// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"db436960","404":"367908a9","498":"0850c128"}[chunkId] + ".chunk.js";
};